module.exports = __webpack_public_path__ + "img/logo.673e2a14.svg";